<template>
  <transition name="fade">
    <div :style="cityModalCoords" v-if="cityPopupIsOpen" class="select-city-popup">
      <div class="select-city-popup-text">
        Ваш город <span>{{currentCity.name}}?</span>
      </div>
      <div class="select-city-popup__footer">
        <button @click="approveCity" class="btn btn--size_ml btn--view_plain">
          <span class="btn__text">Да</span>
        </button>
        <button @click="showCities" class="btn btn--size_ml btn--view_light-grey">
          <span class="btn__text">Выбрать другой</span>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>

import { mapStores } from '@nanostores/vue'
import { setCurrentCity, $currentCity } from '~/js/stores/current-city.js'
import {
  cityModalCoords, openModal, cityPopupIsOpen, closeCityPopup,
} from '~/js/stores/modal.js'

export default {
  setup() {
    return {
      ...mapStores({ currentCity: $currentCity, cityModalCoords, cityPopupIsOpen }),
    }
  },
  methods: {
    showCities() {
      closeCityPopup()
      openModal('city')
    },
    approveCity() {
      setCurrentCity($currentCity.get())
      closeCityPopup()
    },
  },
}
</script>
